import loadGoogleMapsApi from 'load-google-maps-api'

export const maps = () =>
  loadGoogleMapsApi({
    key: window.maps_key,
    libraries: ['places'],
    language: window.language,
  })
